import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { getMembership } from '~/techstyle-shared/react-accounts';

import { getDefaultProductFilters } from './utils/getDefaultProductFilters';

function areFiltersEqual(a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
}

// This is necessary because `useDefaultProductFilters` is used in multiple
// places with different inputs, busting its cache. Without this, the selector
// memoization doesn't work correctly and results in an infinite loop.
// See: https://react-redux.js.org/next/api/hooks#using-memoizing-selectors
export function useDefaultProductFilters(baseFilters, options) {
  const selector = useCallback(
    (state) =>
      getDefaultProductFilters(
        getMembership(state),
        state.domain.tld,
        baseFilters,
        options
      ),
    [baseFilters, options]
  );
  return useSelector(selector, areFiltersEqual);
}
